import * as React from "react";
const SvgHorizontalMenu = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.008 12v3h6V9h-6v3ZM9 12v3h6V9H9v3Zm7.992 0v3h6V9h-6v3Z", fill: "currentColor" })));
export default SvgHorizontalMenu;
